type ManualStepWithModule = {
  moduleName?: string | null;
};

export type ManualStepModuleGroup<TStep extends ManualStepWithModule> = {
  moduleName: string;
  steps: TStep[];
};

export function groupManualStepsByModule<TStep extends ManualStepWithModule>(
  steps: TStep[]
): ManualStepModuleGroup<TStep>[] {
  const groups: ManualStepModuleGroup<TStep>[] = [];
  const moduleIndex = new Map<string, number>();

  for (const step of steps) {
    const moduleName = step.moduleName ?? "Course-Level Content";
    const existingIdx = moduleIndex.get(moduleName);
    if (existingIdx != null) {
      groups[existingIdx].steps.push(step);
      continue;
    }

    moduleIndex.set(moduleName, groups.length);
    groups.push({ moduleName, steps: [step] });
  }

  return groups;
}
